import { Component } from 'react';
import { connect } from 'react-redux';
import { AssignmentType } from 'models/enum';
import { studentSelectors } from 'redux/ducks/student';
import { ButtonLinkIcon, CaseStudyPanel, EmptyEHRInfo } from 'components/common';
import SimulationEhrPanel from '../simulation-ehr-panel/SimulationEhrPanel';

export interface AssignmentInformationProps {
  assignmentType: AssignmentType;
  toggleFlyout: (content: JSX.Element | null) => void;
}

class AssignmentInformation extends Component<AssignmentInformationProps> {
  static displayName = 'AssignmentInformation';

  getFlyoutContent(): JSX.Element {
    const { assignmentType } = this.props;
    switch (assignmentType) {
      case AssignmentType.CASE_STUDY:
        return <CaseStudyPanel />;
      case AssignmentType.SIMULATION:
        return <SimulationEhrPanel />;
      default:
        return <EmptyEHRInfo />;
    }
  }

  render() {
    return (
      <div>
        <ButtonLinkIcon
          iconPrefix="gizmo"
          iconName="information"
          text="Assignment Information"
          onClick={() => this.props.toggleFlyout(this.getFlyoutContent())}
          preventAutoPending
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  assignmentType: studentSelectors.getAssignmentType(state)
});

export { AssignmentInformation as BaseAssignmentInformation };
export default connect(mapStateToProps)(AssignmentInformation);
